import { z } from 'zod';

export class VALIDATE {
    static ERRORS_EXISTS = 'errors_exists';
    static MISSING_XY_OR_CITY_STREET = 'missing_xy_or_city_street';
    static BOTH_CITY_STREET_SHOULD_BE_SELECTED = 'both_city_street_should_be_selected';
    static Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED = 'y_should_be_selected_if_x_is_selected';
    static X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED = 'x_should_be_selected_if_y_is_selected';
}

export const OptionSchema = z.object({
    id: z.string(),
    label: z.string(),
    exampleValues: z.array(z.union([z.string(), z.number()])).catch([]),
});
export type OptionType = z.infer<typeof OptionSchema>;

export const ColumnElementSelectSchema = z.object({
    type: z.literal('select'),
    error: z.string().default(''),
    warning: z.string().default(''),
    section: z.string(),
    required: z.boolean().default(false),
    multi: z.boolean().default(false),
    visible: z.union([z.boolean(), z.null()]).default(null),
    id: z.string(),
    label: z.string(),
    selectedOptionId: z.string(),
    availableOptions: z.array(z.string()),
    optionsErrors: z
        .array(
            z.object({
                id: z.string(),
                message: z.string(),
            })
        )
        .catch([]),
    optionsWarnings: z
        .array(
            z.object({
                id: z.string(),
                message: z.string(),
            })
        )
        .catch([]),
    visibleWarning: z.boolean().default(true),
});
export type ColumnElementSelectType = z.infer<typeof ColumnElementSelectSchema>;

export const ColumnElementCheckboxSchema = z.object({
    section: z.string(),
    type: z.literal('checkbox'),
    id: z.string(),
    label: z.string(),
    checked: z.boolean().catch(false),
    enabled: z.boolean().catch(false),
    order: z.number().optional(),
});
export type ColumnElementCheckboxType = z.infer<typeof ColumnElementCheckboxSchema>;

export type CallbacksType = {
    onValidate: (
        valid: boolean,
        reasons: string[]
        // matchedFields: {id: string, matchedWith: string}[],
    ) => void;
};

export const SectionSchema = z.object({
    id: z.string(),
    label: z.string(),
});
export type SectionType = z.infer<typeof SectionSchema>;

export const ColumnElementSchema = z.union([
    ColumnElementSelectSchema,
    ColumnElementCheckboxSchema,
]);
export type ColumnElementType = z.infer<typeof ColumnElementSchema>;

export const ColumnSettingsSchema = z.object({
    elements: z.array(ColumnElementSchema),
    sections: z.array(SectionSchema).optional(),
    options: z.array(OptionSchema),
});
export type ColumnSettingsType = z.infer<typeof ColumnSettingsSchema>;
